/**
 * Styled Components - Created by cazarez on 10/04/18.
 */
import styled from 'styled-components'
import { WHITE } from '../DesignerTool/constants'
import { GRAY_DARK, GRAY_LIGHT, BLUE_LIGHT, BLUE } from '../../theme/colors'
import Button from 'antd/lib/button'
import Icon from 'antd/lib/icon'
import Skeleton from 'antd/lib/skeleton'

interface InfoTextProps {
  secondary?: boolean
  bold?: boolean
  centered?: boolean
  paddingLeftMobile?: boolean
}

interface StyledProps {
  index?: number
  secondary?: boolean
  extendedList?: boolean
}

export const MainTitle = styled.div`
  font-size: 24px;
  font-weight: bold;
  height: 33px;
  letter-spacing: 0.3px;
  line-height: 33px;
  margin: 24px 0;
  text-align: center;
  width: 100%;
`

export const Title = styled.div`
  color: ${GRAY_DARK};
  font-size: 24px;
  font-weight: bold;
  height: 33px;
  letter-spacing: 0.3px;
  line-height: 33px;
  margin: 24px 0;
  text-align: center;
  width: 100%;
  margin-bottom: ${({ secondary }: StyledProps) => secondary ? '8px' : 'unset'};
  &:hover {
    cursor: pointer;
  }

  @media (max-width: 768px) {
    font-size: 20px;
  }
`

export const TitleName = styled.div`
  color: ${GRAY_DARK};
  font-size: 18px;
  font-weight: bold;
  font-family: Avenir;
  height: 33px;
  letter-spacing: 0.3px;
  line-height: 33px;
  margin: 24px 0;
  text-align: center;
  width: 100%;

  &:hover {
    cursor: pointer;
  }

  @media (max-width: 768px) {
    font-size: 20px;
  }
`

export const DesignName = styled.div`
  font-size: 15px;
  color: #f7aa4d;
  line-height: 1;
`

export const StyledImage = styled.img`
  object-fit: contain;
  width: 100%;
  border-radius: 5px;
  max-width: 300px;
  ${({ secondary }: StyledProps) => secondary ? `
    object-fit: cover;
    border-radius: 5px;
    max-width: 300px;
    max-height: 300px;
    height: 300px;
    width: 100%;
    background: radial-gradient(at 50% 70%, #ffffff, #d7d7d7, #bfbfbf);
  ` : ''}
  &:hover {
    cursor: pointer;
  }
`

export const SubTitle = styled.div`
  text-align: center;
  color: #797979;
  font-size: 15px;
  background: whitesmoke;
  width: fit-content;
  margin: 0 auto;
  margin-bottom: 22px;
  font-weight: 600;
  font-family: Avenir;
  padding: 4px 22px;
  padding-top: 6px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
`

export const DescriptionDiv = styled.div`
  flex: 1;
  padding: 20px 30px;
  padding-bottom: 0;
  border-right: 1px solid lightgray;
  &:last-child {
    border-right: unset;
  }
  &.slick-slide {
    display: flex;
    flex-flow: column;
    text-align: left;
  }
  @media (max-width: 768px) {
    padding-left: 36px;
  }
  @media (max-width: 698px) {
    padding: 20px 12px;
    padding-left: 12px !important;
  }
`

export const Text = styled.div`
  color: ${GRAY_DARK};
  font-size: 14px;
  letter-spacing: 0.11px;
  line-height: 23px;
  transition: all .25s;
  @media (max-width: 768px) {
    font-size: 13px;
  }
`

export const TextUpgrade = styled.div`
  color: ${GRAY_DARK};
  font-size: 14px;
  letter-spacing: 0.11px;
  line-height: 23px;
  transition: all .25s;
  margin-bottom: 6px;
  &:first-child {
    margin-top: -6px;
  }
  &:last-child {
    margin-bottom: 0px;
  }
  @media (max-width: 768px) {
    font-size: 13px;
  }
  @media (max-width: 698px) {
    margin-left: -12px;
    margin-right: -12px;
    &:last-child {
      margin-bottom: 8px;
    }
  }
`

export const TextExtended = styled.div`
  color: ${GRAY_DARK};
  font-size: 14px;
  font-family: Avenir;
  letter-spacing: 0.11px;
  line-height: 23px;
  transition: all .25s;
  animation: fade-in-text-extended 0.3s cubic-bezier(0.390, 0.575, 0.565, 1.000) 
  ${({ index }: StyledProps) => index ? index * 0.15 : 0 }s both;
  @media (max-width: 768px) {
    text-align: center;
    font-size: 13px;
  }

  @keyframes fade-in-text-extended {
    0% {
      transform: translateY(-10px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`

export const ShowMore = styled.p`
  color: ${BLUE};
  font-size: 16px;
  letter-spacing: 0.11px;
  line-height: 23px;
  cursor: pointer;
  @media (max-width: 768px) {
    text-align: center;
  }
`

export const Container = styled.div`
  background-color: ${WHITE};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 48px;
  position: relative;
  font-family: Avenir;
`

export const Row = styled.div`
  width: 100%;
  display: ${({ extendedList }: StyledProps) => extendedList ? 'none' : 'flex'};
  flex-direction: row;
  justify-content: space-evenly;
  padding: 0 32px;
  animation: fade-in-row 0.6s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @media (max-width: 768px) {
    display: none;
  }

  @keyframes fade-in-row {
    0% {
      transform: translateY(50px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`

export const MobileRowContainer = styled.div`
  transform: translate3d(0, 0, 0);
`

export const MobileRow = styled.div`
  width: 780px;
  transform: translate3d(0, 0, 0);
  display: flex;
`

export const MobileColumnContainer = styled.div`
   width: 195px;
   float: left;
   transition: opacity 1s ease-in-out;
   position: relative;
`

export const Column = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-right: 1px solid lightgray;
  animation: fade-in-column 0.6s cubic-bezier(0.390, 0.575, 0.565, 1.000) 
    ${({ index }: StyledProps) => index ? index * 0.2 : 0 }s both;

  @media (max-width: 768px) {
    padding-left: 36px;
    width: 100%;
  }

  @keyframes fade-in-column {
    0% {
      transform: translateY(50px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
  &:last-child {
    border-right: none;
  }
`

export const ColumnRating = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 4px 20px;
  border-right: 1px solid lightgray;
  animation: fade-in-column 0.6s cubic-bezier(0.390, 0.575, 0.565, 1.000) 
    ${({ index }: StyledProps) => index ? index * 0.2 : 0 }s both;

  @media (max-width: 552px) {
    padding: 0px 10px;
    width: 100%;
  }

  @keyframes fade-in-column {
    0% {
      transform: translateY(50px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
  &:last-child {
    border-right: none;
  }
`

export const ColumnHeader = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  /* animation: fade-in-column 0.6s cubic-bezier(0.390, 0.575, 0.565, 1.000) both; */
  animation: fade-in-column 0.6s cubic-bezier(0.390, 0.575, 0.565, 1.000) 
  ${({ index }: StyledProps) => index ? index * 0.2 : 0 }s both;

  @media (max-width: 552px) {
    padding: 0px 10px;
    width: 100%;
  }

  @keyframes fade-in-column {
    0% {
      transform: translateY(50px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`

export const ColumnContainer = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${GRAY_LIGHT};
`

export const HeaderText = styled.div`
  margin: 0 auto;
  margin-bottom: 10px;
  text-align: center;
  color: ${GRAY_DARK};
  font-size: 16px;
  letter-spacing: 0.11px;
  line-height: 23px;
  text-align: center;
  padding: 0 16px;

  @media (max-width: 768px) {
    margin-bottom: 0px;
    width: 100%;
  }
`

export const InfoText = styled.div`
  color: ${GRAY_DARK};
  font-size: 16px;
  letter-spacing: 0.11px;
  line-height: 23px;
  font-family: Avenir;
  font-weight: ${({ bold }: InfoTextProps) => bold ? 'bold' : 'auto'};
  margin-bottom: 10px;
  text-align: ${({ centered }: InfoTextProps) =>
    centered ? 'center' : 'left'};

  @media (max-width: 552px) {
    letter-spacing: 'unset';
    line-height: 'unset';
    font-size: 13px;
    padding-left: ${({ paddingLeftMobile }: InfoTextProps) => (paddingLeftMobile ? '7px' : '0px')};
  }
  &:last-child {
    color: ${({ secondary }: InfoTextProps) => secondary ? BLUE : 'auto'};
  }
`

export const PriceColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 20px;
  border-right: 1px solid lightgray;
  &:last-child {
    border-right: unset;
  }
  @media (max-width: 768px) {
    justify-content: flex-start !important;
    padding-left: 36px;
    width: 100%;
  }
`

export const PriceTitlesContainer = styled.div`
  margin-right: 24px;
`

export const PricesRow = styled.div`
  display: flex;
  margin-top: 20px;
  flex-wrap: wrap;
  @media (min-width: 320px) and (max-width: 480px) {
    justify-content: space-evenly;
  }
`

export const AvailablePrices = styled.div`
  margin-right: 30px;

  @media (min-width: 320px) and (max-width: 480px) {
    margin: 0;
  }

  @media (min-width: 481px) and (max-width: 768px) {
    margin-right: 20px;
  }
`

export const Subtitle = styled.div`
  width: 100%;
  color: ${GRAY_DARK};
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.23px;
  line-height: 25px;
  padding: 0 32px;
  margin: 30px 0 4px;
  display: flex;
  align-items: center;
`

export const IconContainer = styled.div`
  margin-right: 5px;
`

export const BannerMaterialContainer = styled.div`  
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 0px 8px;
  padding-bottom: 10px;
  border-right: 1px solid lightgray;
  &:last-child {
    border-right: unset;
  }
  @media (max-width: 768px) {
    padding: 0px 10px;
    width: 100%;
  }
  @media (max-width: 698px) {
    padding: 0px 6px;
  }
`

export const BannerMaterial = styled.img`
  max-width: 64px;
  width: 70px;
  border-radius: 3px;
`

export const ShareButton = styled(Button)`
  background-color: ${BLUE_LIGHT};
  color: ${WHITE};
  border-radius: 5px;
  border: none;
  height: 40px;
  padding: 0 22px;
  box-shadow: 1px 2px 3px 0px #dadada;
  transition: all .25s;
  position: absolute;
  right: 50px;
  top: 40px;
  &:hover {
    color: ${BLUE_LIGHT};
    border: 1px solid ${BLUE_LIGHT};
  }
  &:disabled {
    background: #e2e2e2;
  }

  @media (max-width: 768px) {
    display: none;
  }
`

export const GenderButtons = styled.div`
  border-top: 1px solid #f1f1f1;
  border-radius: 5px;
  box-shadow: 0px 1px 4px -1px #959595;
  margin-top: 8px;
  margin-bottom: 4px;
`

export const SelectGender = styled.div`
  font-size: 9px;
  margin-bottom: -6px;
  color: #bdbdbd;
`

export const MaleButton = styled(Icon)`
  color: #2196f3;
  padding: 6px 8px;
  border-right: 1px solid lightgray;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  transition: all .25s;
  ${({ secondary }: StyledProps) => secondary ? `
    box-shadow: inset 0px 1px 3px 0px #b1b1b1, 0px 0px 2px 1px #ffffff;
    border-bottom: 1px solid #e2e2e2;
  ` : ''}
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const FemaleButton = styled(Icon)`
  color: deeppink;
  padding: 6px 8px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  transition: all .25s;
  ${({ secondary }: StyledProps) => secondary ? `
    box-shadow: inset 0px 1px 3px 0px #b1b1b1, 0px 0px 2px 1px #ffffff;
    border-bottom: 1px solid #e2e2e2;
  ` : ''}
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const CloseButton = styled.div`
  position: absolute;
  left: 50px;
  top: 36px;
  font-size: 14px;
  padding: 4px 12px;
  border-radius: 25px;
  border: 1px solid #cfcfcf;
  box-shadow: 0px 2px 3px -1px #cacaca;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background: gray;
    color: ${WHITE};
  }
  @media (max-width: 698px) {
    top: 78px;
    left: 20px;
  }
`

export const CloseFloatingButton = styled.div`
  position: absolute;
  left: 30px;
  border: 1px solid #8c8c8c;
  padding: 4px 8px;
  border-radius: 5px;
  color: #d1d1d1;
  font-size: 12px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background: gray;
    color: ${WHITE};
  }
`

export const CloseFloatingButtonMobile = styled.div`
  position: fixed;
  padding: 4px 18px;
  border-radius: 25px;
  color: #ffffff;
  transition: all .25s;
  left: calc(50% - 46px);
  bottom: 18px;
  background: #939393d9;
  z-index: 2;
  font-size: 14px;
  box-shadow: 0px 2px 4px -1px gray;
  display: none;
  @media (max-width: 768px) {
    display: flex;
  }
  &:hover {
    cursor: pointer;
    background: gray;
    color: ${WHITE};
  }
`

export const ShareButtonMobile = styled(Button)`
  display: none;
  background-color: ${BLUE_LIGHT};
  color: ${WHITE};
  border-radius: 5px;
  border: none;
  height: 40px;
  padding: 0 22px;
  box-shadow: 1px 2px 3px 0px #dadada;
  transition: all .25s;
  margin: 0 auto;
  margin-bottom: -20px;
  margin-top: -8px;
  &:hover {
    color: ${BLUE_LIGHT};
    border: 1px solid ${BLUE_LIGHT};
  }
  &:disabled {
    background: #e2e2e2;
  }

  @media (max-width: 768px) {
    position: unset;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 14px;
  }
`

export const StyledIcon = styled(Icon)``

export const FlexBox = styled.div` 
  display: flex;
  justify-content: flex-start;
`

export const ScrollRight = styled(Button)`
  background-color: ${BLUE_LIGHT};
  color: ${WHITE};
  border-radius: 5px;
  border: none;
  height: 40px;
  padding: 0 22px;
  box-shadow: 1px 2px 3px 0px #dadada;
  transition: all .25s;
  position: absolute;
  right: 50px;
  top: 40px;
  &:hover {
    color: ${BLUE_LIGHT};
    border: 1px solid ${BLUE_LIGHT};
  }
  &:disabled {
    background: #e2e2e2;
  }
`

export const Arrow = styled.img`
  height: 60px !important;
  width: 50px !important;
  border-radius: 5px;
  padding: 19px !important;
  text-align: center !important;
  z-index: 3 !important;
  border: 0.2px solid rgba(220,220,220,0.34) !important;
  filter: brightness(10.5);
  background-color: #0000003b !important;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.07) !important;
`

export const SliderContainer = styled.div`
  width: 100%;
  display: ${({ extendedList }: StyledProps) => extendedList ? 'block' : 'none'};

  @media (max-width: 768px) {
    display: block;
  }

  .slick-arrow {
    position: fixed;
  }

  .slick-prev {
    margin-left: 30px;
  }

  .slick-next {
    margin-right: 30px;
  }

  .slick-initialized .slick-slide {
    display: flex;
    justify-content: center;
  }
  .slick-track:after {
    display: none;
  }
`

export const SliderContainerSticky = styled.div`
  width: 100%;
  display: ${({ extendedList }: StyledProps) => extendedList ? 'block' : 'none'};

  @media (max-width: 768px) {
    display: block;
  }

  .slick-arrow {
    position: fixed;
  }

  .slick-prev {
    margin-left: 30px;
  }

  .slick-next {
    margin-right: 30px;
  }

  .slick-initialized .slick-slide {
    display: flex;
    justify-content: center;
  }
  .slick-track:after {
    display: none;
  }
`

export const LoadingContainer = styled.div`
  position: fixed;
  height: 100vh;
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
`

export const LoadingContainerBlank = styled.div`
  position: fixed;
  height: 100vh;
  width: 100%;
  background: #ffffff80;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
`

export const StickyDiv = styled.div`
  position: fixed;
  top: 0;
  z-index: 10;
  height: 60px;
  display: flex;
  padding: 0 32px;
  align-items: center;
  background: #323232;
  width: 100vw;
  left: 0;
  justify-content: space-evenly;
  box-shadow: 0px 2px 4px -1px #a0a0a0;
  color: ${WHITE};
  animation: fade-in-topBar 0.35s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-topBar {
    0% {
    transform: translateY(-15px);
      opacity: 0;
    }
    100% {
    transform: translateY(0);
      opacity: 1;
    }
  }
  @media (max-width: 768px) {
    display: none;
  }
`

export const StickyDivMobile = styled.div`
  display: ${({ extendedList }: StyledProps) => extendedList ? 'flex' : 'none'};
  position: fixed;
  top: 0;
  z-index: 10;
  height: 60px;
  padding: 0 32px;
  align-items: center;
  background: #323232;
  width: 100vw;
  left: 0;
  justify-content: space-evenly;
  box-shadow: 0px 2px 4px -1px #a0a0a0;
  color: ${WHITE};
  animation: fade-in-topBar 0.35s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-topBar {
    0% {
    transform: translateY(-15px);
      opacity: 0;
    }
    100% {
    transform: translateY(0);
      opacity: 1;
    }
  }
  @media (max-width: 768px) {
    display: flex;
  }
`

export const ProductNameDiv = styled.div`
  padding: 0 20px;
  flex: 1;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  font-family: Avenir;
  color: ${WHITE};
  position: relative;
  display: flex;
  flex-flow: column;
  align-items: center;
  @media (max-width: 768px) {
    border-left: 1px solid #4b4b4b;
    &:first-child {
      border-left: none;
    }
  }
`

export const SubtitleDiv = styled.div`
  font-weight: normal;
  font-size: 10px;
  font-family: Avenir;
  margin-bottom: -2px;
`

export const TriangleDown = styled.div`
  position: absolute;
  top: calc(100% + 11px);
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 7px 23px 0px 23px;
  border-color: #323232 transparent transparent transparent;
  filter: drop-shadow(0px 2px 1px #c7c7c7);
`

export const DescriptionTitle = styled.div`
  font-weight: bold;
  font-family: Avenir;
  font-size: 15px;
  margin-bottom: 10px;
  margin-top: 4px;
`

export const ImageContainer = styled.div`
  position: relative;
`

export const RemoveButton = styled(Icon)`
  position: absolute;
  right: -6px;
  top: -6px;
  background: white;
  border-radius: 25px;
  padding: 4px;
  font-size: 11px;
  box-shadow: 1px -1px 4px -1px #bdbdbd;
  color: #4e4d52;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
  @media (max-width: 698px) {
    font-size: 13px;
  }
`

export const HowItFits = styled.div`
  border: 1px solid #679bb2;
  width: fit-content;
  font-size: 12px;
  padding: 2px 10px;
  border-radius: 25px;
  color: #397997;
  box-shadow: 1px 2px 4px -1px #e8e8e8;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background: #397997;
    color: ${WHITE};
  }
`

export const TitleCustom = styled.div`
  display: flex;
`

export const SubtitleCustom = styled.div`
  font-weight: normal;
  margin-left: 10px;
  font-size: 12px;
`

export const UpgradeName = styled.div`
  display: flex;
  font-weight: 500;
  flex-wrap: wrap;
`

export const ViewDetails = styled.div`
  margin-left: 14px;
  color: ${BLUE};
  font-weight: normal;
  font-size: 13px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const UpgradeOptions = styled.div`
  display: flex;
  font-weight: normal;
  flex-wrap: wrap;
`

export const UpgradeValue = styled.div`
  margin-right: 6px;
  &:first-child {
    margin-left: 2px;
  }
  &:last-child {
    margin-right: 2px;
  }
`

export const InfoBodyModern = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
`

export const InfoImage = styled.img`
  max-width: 75vw;
  border-radius: 5px;
  display: block;
  width: 100%;
  @media (max-width: 768px) {
    display: none;
  }
`

export const InfoImageMobile = styled.img`
  max-width: 886px;
  border-radius: 5px;
  width: 100%;
  display: none;
  margin-top: 0px;
  @media (max-width: 768px) {
    display: block;
  }
`

export const InfoURL = styled.a`
  color: ${BLUE};
`

export const maskBlurred = {
  backdropFilter: 'blur(3px)'
}

export const buttonStyleModern = {
  background: WHITE,
  color: 'black',
  border: '1px solid black',
  fontWeight: 600,
  width: '28px',
  padding: 0,
  borderRadius: '25px',
  height: '28px',
}

export const MenIcon = styled(Icon)`
  color: #2196f3;
`
export const WomenIcon = styled(Icon)`
  color: deeppink;
  margin-left: 6px;
`

export const GendersContainer = styled.div`
  position: absolute;
  bottom: 10px;
  right: 18px;
  display: flex;
  align-items: center;
`

export const YouthLabel = styled.div`
  font-size: 9px;
  color: #549c8c;
  font-family: Avenir;
  font-weight: bold;
  margin-left: 6px;
  text-align: right;
  line-height: 1.5;
  max-width: 38px;
`

export const SkeletonBody = styled.div`
  display: flex;
  min-height: 55vh;
  padding-top: 108px;
  justify-content: center;
  width: 100%;
`

export const CardSkeleton = styled.div`
  max-width: 400px;
  width: 100%;
  margin-left: 128px;
  margin-right: 128px;
  display: flex;
  flex-flow: column;
  align-items: center;
  @media (max-width: 1024px) {
    margin-left: 0px;
    margin-right: 0px;
  }
`

export const IconSkeleton = styled(Skeleton)`
  margin-bottom: 50px;
  width: fit-content;
  padding: 0;
  li {
    background: #f1f1f1 !important;
  }
  .ant-skeleton-header {
    padding-right: 0;
  }
  .ant-skeleton-avatar {
    width: 116px;
    height: 100px;
    border-radius: 7px;
  }
`

export const ParagraphSkeleton = styled(Skeleton)`
  margin-bottom: 50px;
  li {
    background: #f1f1f1 !important;
  }
  .ant-skeleton-title {
    border-radius: 3px;
  }
`

export const NavSkeleton = styled(Skeleton)`
  max-width: 70%;
  margin-bottom: 30px;
  li {
    background: #f1f1f1 !important;
  }
  .ant-skeleton-title {
    border-radius: 25px;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/ComparisonEngine/styledComponents.tsx